import {createSwiper} from "./createSwiper";

export const ratesSection = function() {
    var ratesSection = $('#currencies-rates');

    if (ratesSection.length) {
        refreshRates();
    }

    function refreshRates() {
        var endpoint = $('#rates-switch').data('target'),
            time = 30,
            timeOutput = $('.exchange-rate-refresh'),
            rateCards = $('#currencies-rates .card'),
            ratesContainer = $('#rates-container'),
            trends = $('.trend');

        rateCards.length && setInterval(countdown, 1000);

        function countdown() {
            time--;
            time === 0 && updateRates();
            timeOutput.text(time + 's');
        }

        function updateRates() {
            time = 30;
            [...trends].forEach(trend => {
                trend.parentNode.classList.add('ghost-item')
            })

            $.ajax({url: endpoint})
                .done(function (data) {
                    var rates = data.currenciesRate || [];

                    if (!rates.length) {
                        var emptyText = ratesContainer.data('empty');
                        ratesContainer.html(
                            '<p>' + emptyText + '</p>'
                        );
                        return;
                    }

                    rateCards.each(function (i) {
                        var rate = rates[i],
                            self = $(this);

                        ['sell', 'buy'].forEach(function (type) {
                            self.find('.rate-' + type).text(rate[type].formatRate);
                            getTrendClass(
                                self.find('.trend .' + type + '-icon'),
                                rate[type].trend
                            );
                        });
                    });

                    [...trends].forEach(trend => {
                        trend.parentNode.classList.remove('ghost-item')
                    })
                });
        }

        function getTrendClass(el, trend) {
            var trendDirection = trend === 'FALLING' ? 'down' : 'up';
            var parent = el.parent('.trend');

            parent.removeClass('trend-up trend-down');
            el.removeClass('icon-up icon-down');
            el.addClass('icon-' + trendDirection);
            parent.addClass('trend-' + trendDirection);
        }

    }

    createSwiper("#swiper-rates");

}
